module.exports = __webpack_public_path__ + "static/img/IMG_20170325_183651.61b9dc65.jpg";